module.exports = "/images/vendor/flag-icon-css/flags/1x1/by.svg?80b2d2dd15003da07957e37b5d7aef23";